<template>
  <div style="padding: 16px;">
    <div class="breadcrumb">
      <v-breadcrumb>
        <!-- <v-breadcrumb-item>
          <v-icon type="home"></v-icon>
          <a @click="() => $router.push('/student/dashboard')">Dashboard </a>
        </v-breadcrumb-item> -->
        <v-breadcrumb-item>
          <span>Notifications</span>
        </v-breadcrumb-item>
      </v-breadcrumb>
    </div>

    <div class="notifications-wrap">

      <v-tabs :active-tab-key="activeTab">

        <v-tab-pane tab-key="unReadNotifications" tab="Unread Notifications">
          <div class="table">
            <div class="trow">
              <div class="thead text">Text</div>
              <div class="thead student-id">Student ID</div>
              <div class="thead email">e-Mail</div>
              <div class="thead phone-number">Phone Number</div>
              <div class="thead actions">Actions</div>
            </div>
            <div class="trow" v-for="notification in unreadNotifications" :key="notification.id" v-if="notifications">
              <div class="tdata text">{{notification.text}}</div>
              <div class="tdata student-id">{{notification.from.seq_id}}</div>
              <div class="tdata email">{{notification.from.personal_details.personal_email || notification.from.personal_details.email}}</div>
              <div class="tdata phone-number">{{notification.from.personal_details.phone_number}}</div>
              <div class="tdata actions">
                <v-button type="primary" @click="() => readNotification(notification)">Mark as Read!</v-button>
              </div>
            </div>
          </div>
        </v-tab-pane>

        <v-tab-pane tab-key="readNotifications" tab="Read Notifications">
          <div class="table">
            <div class="trow">
              <div class="thead r-text" @click="() => sortNotifications('text')">Text</div>
              <div class="thead r-student-id" @click="() => sortNotifications('from_seq_id')">Student ID</div>
              <div class="thead r-email" @click="() => sortNotifications('from_email')">e-Mail</div>
              <div class="thead r-phone-number" @click="() => sortNotifications('from_phone_number')">Phone Number</div>
            </div>
            <div class="trow" v-for="notification in readNotifications" :key="notification.id" v-if="notifications">
              <div class="tdata r-text">{{notification.text}}</div>
              <div class="tdata r-student-id">{{notification.from.seq_id}}</div>
              <div class="tdata r-email">{{notification.from_email}}</div>
              <div class="tdata r-phone-number">{{notification.from_phone_number}}</div>
            </div>
          </div>
        </v-tab-pane>
      </v-tabs>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import fb from '@/firebase'

export default {
  name: 'EmployeeNotifications',
  data () {
    return {
      activeTab: null,
      unreadNotifications: [],
      readNotifications: [],
      sorted: {}
    }
  },
  computed: {
    ...mapGetters([
      'notifications'
    ])
  },
  watch: {
    notifications: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getNotifications')
        } else {
          this.readNotifications = []
          this.unreadNotifications = []
          val.forEach(item => {
            if (item.read_status) {
              item.from_seq_id = item.from.seq_id
              item.from_email = item.from.personal_details.personal_email || item.from.personal_details.email
              item.from_phone_number = item.from.personal_details.phone_number
              this.readNotifications.push(item)
            } else {
              this.unreadNotifications.push(item)
            }
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    readNotification (notification) {
      this.$store.dispatch('updateNotification', {id: notification.id, payload: {read_status: true}})
    },
    sortNotifications (col) {
      if (this.sorted[col] === undefined) {
        this.sorted[col] = true
      } else {
        this.sorted[col] = !this.sorted[col]
      }

      let notifications = [...this.readNotifications]
      if (this.sorted[col]) {        
        this.readNotifications = notifications.sort((x, y) => (x[col] || '') > (y[col] || '') ? 1 : (y[col] || '') > (x[col] || '') ? -1 : 0)
      } else {
        this.readNotifications = notifications.sort((x, y) => (x[col] || '') > (y[col] || '') ? -1 : (y[col] || '') > (x[col] || '') ? 1 : 0)
      }
    }
  }
}
</script>

<style scoped>
.notifications-wrap {
  margin-top: 30px;
}
.table {
  width: 100%;
  margin-top: 8px;
}
.table .trow {
  display: flex;
  flex-direction: row;
}
.table .thead {
  font-size: 15px;
  padding: 7px 6px;
  background-color: #404040;
  color: ivory;
  border: 1px solid rgba(255, 255, 240, .2);
  cursor: pointer;
}
.table .thead:first-child {
  border-top-left-radius: 2px;
}
.table .thead:last-child {
  border-top-right-radius: 2px;
}
.table .tdata {
  font-size: 13px;
  padding: 5px 6px;
  border: 1px solid rgba(131, 127, 127, 0.137);
}
.trow .text {
  width: 30%;
}
.trow .student-id {
  width: 15%;
}
.trow .email {
  width: 25%;
}
.trow .phone-number {
  width: 15%;
}
.trow .actions {
  width: 15%;
  text-align: center;
}
.trow .r-text {
  width: 30%;
}
.trow .r-student-id {
  width: 15%;
}
.trow .r-email {
  width: 30%;
}
.trow .r-phone-number {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/views/Employee/EmployeeNotifications.vue